import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatusSharedComponent } from './status.component';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { TextButtonSharedModule } from '../../atoms/text.button/text.button.module';

@NgModule({
    declarations: [
        StatusSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        TextButtonSharedModule
    ],
    exports: [
        StatusSharedComponent
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class StatusSharedModule {}
